import { createApp } from 'vue'
import App from './App.vue' 
import router from './router'
import './assets/css/mobile.css'
// Shared look for every page under Calculators. Global on purpose, but every rule inside is
// a descendant of .calc-page, so it cannot reach pages that are not calculators.
import './assets/css/calculatorKit.css'
// Shared look for the Insights pages; layered on calculatorKit, every rule under .ins-page.
import './assets/css/insightsKit.css'
import { installActAsInterceptors } from './helpers/impersonation.js'

// "View as": X-GSD-Act-As on every GSWebAPIv2 call while impersonating, as swiftMarketing does.
installActAsInterceptors()

createApp(App).use(router).mount('#app');

const userName = localStorage.getItem('user_name');
const userId =  localStorage.getItem('azure_id');

window.dataLayer.push({
  'event': 'login',
  'userId': userId //this number must be replaced with an actual User ID
})
